import { useAppSelector } from '../../../redux/store-typing'
import { useEffect, useState } from 'react'
import { supabase } from '../../../App'
import { isEmpty } from '../../../lib/isEmpty'
import { toast } from 'react-toast'

interface ProfileTypes {
    authData: any
    products: any
}

const useUserProfile = () => {
    const [user, setUser] = useState<ProfileTypes['authData'] | null>(null)

    const authData = useAppSelector((state) => state.auth.data)

    const loadProfile = async () => {
        const userResponse = supabase.auth.user()
        if (userResponse) {
            setUser(user)
        }
    }

    const updateUser = async ({
        firstName,
        secondName,
        currency,
        email,
    }: Record<string, string>) => {
        try {
            await supabase.auth.update({ email })
            await supabase.auth.update({
                data: {
                    first_name: firstName,
                    second_name: secondName,
                    currency,
                },
            })
            toast.success(`Изменено!`)
        } catch (err) {
            console.log('ERROR', err)
            toast.error('Ошибка!')
        }
    }

    useEffect(() => {
        if (isEmpty(authData)) {
            loadProfile()
            return
        }
        setUser(authData)
    }, [authData])

    return { user, updateUser }
}

export type { ProfileTypes }

export { useUserProfile }
